import { User } from 'oidc-client-ts';
import { userManager } from './oidcConfig';

export async function overrideAuth({
  accessToken,
  refreshToken,
  clientId
}: Exclude<(typeof window)['overrideAuthentication'], void>) {
  Object.assign(userManager.settings, { client_id: clientId });
  // @ts-expect-error undefined _client
  Object.assign(userManager._client.settings, { client_id: clientId });

  if (sessionStorage.getItem('auth-overriden') === 'overriden') return;

  const config = userManager.settings;
  await userManager.removeUser();
  const epochNow = Date.now() / 1000;
  await userManager.storeUser(
    new User({
      access_token: accessToken,
      refresh_token: refreshToken,
      token_type: 'Bearer',
      expires_at: epochNow - 1,
      scope: config.scope,
      // stub profile
      profile: {
        aud: [],
        exp: epochNow - 1,
        iat: epochNow - 2,
        iss: '',
        sub: ''
      }
    })
  );
  sessionStorage.setItem('auth-overriden', 'overriden');
}
